module.exports = __webpack_public_path__ + "img/valencia.957acc6c.png";